import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import { Box, Container, Typography, Grid } from "@mui/material";
import { SiGitlab } from "react-icons/si";

const contactLinks = [
  {
    icon: <EmailIcon sx={{ fontSize: 32 }} />,
    label: "Email",
    value: "Kayleemburch@gmail.com",
    href: "mailto:kayleemburch@gmail.com?subject=&body=",
  },
  {
    icon: <LinkedInIcon sx={{ fontSize: 32 }} />,
    label: "LinkedIn",
    value: "kaylee-burch",
    href: "https://www.linkedin.com/in/kaylee-burch-419a671b4/",
  },
  {
    icon: <SiGitlab size={28} />,
    label: "GitLab",
    value: "kayleemburch",
    href: "https://gitlab.com/kayleemburch",
  },
  {
    icon: <GitHubIcon sx={{ fontSize: 32 }} />,
    label: "GitHub",
    value: "kayleeburch",
    href: "https://github.com/kayleeburch",
  },
];

export default function Contact() {
  return (
    <Box sx={{ py: { xs: 8, md: 12 } }}>
      <Container maxWidth="md">
        <Box sx={{ textAlign: 'center', mb: 5 }}>
          <Typography
            variant="h3"
            component="h2"
            sx={{
              mb: 1,
              fontWeight: 'bold',
              background: 'linear-gradient(45deg, #72efdd, #7E4DE2)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Get In Touch
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: 'rgba(255,255,255,0.7)',
              fontSize: '1.1rem',
            }}
          >
            Interested in working together? Let's connect.
          </Typography>
        </Box>

        <Grid container spacing={2} justifyContent="center">
          {contactLinks.map((link, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Box
                component="a"
                href={link.href}
                target={link.label === "Email" ? undefined : "_blank"}
                rel={link.label === "Email" ? undefined : "noopener noreferrer"}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  p: 2.5,
                  borderRadius: 2,
                  backgroundColor: 'rgba(255, 255, 255, 0.03)',
                  border: '1px solid rgba(114, 239, 221, 0.08)',
                  textDecoration: 'none !important',
                  transition: 'all 0.2s ease-in-out',
                  '&:hover': {
                    backgroundColor: 'rgba(114, 239, 221, 0.06)',
                    borderColor: 'rgba(114, 239, 221, 0.2)',
                    transform: 'translateY(-2px)',
                  },
                }}
              >
                <Box
                  sx={{
                    color: '#7E4DE2',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  {link.icon}
                </Box>
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      color: 'rgba(255,255,255,0.5)',
                      textTransform: 'uppercase',
                      letterSpacing: 1,
                      fontSize: '0.7rem',
                    }}
                  >
                    {link.label}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'white !important',
                      fontWeight: 500,
                    }}
                  >
                    {link.value}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
